import React from 'react'
import { useState, useEffect } from 'react';
const Bladge = ({ mat, ques, row, ans, storfl, ch1, ch, last }) => {
  const [showFlash, setShowFlash] = useState(false);
  const [crtAnd, setCrtAnd] = useState([]);
  const [huray, setHuray] = useState(0);
  const [m, setM] = useState(0);
  let TotalCorrectAns = 0;
  let Pop_up = 0
  let TotalQuestion = 0
  let perCentage = 0
  const [display, setdisplay] = useState(1)
  const anskey = []
  const Userans = []
  let len = 0
  const matArg = []
  let temp = 0;
  // let total;
  let temp2;
  let m1 = 0, m2 = 0, m3 = 0;


  if (last) {
    if (ch == "a") {
      for (let i = 0; i < ques; i++) {
        for (let j = 0; j < row; j++) {
          temp = temp + mat[i][j]
          anskey.push(temp)
          temp = 0;
        }
        if (anskey[i] == ans[i]) {
          TotalCorrectAns++;
        }
      }
      // console.log(total)
      TotalQuestion = ques
    }


    if (ch == "m" && last && ans) {
      temp = 1;
      if (ques == 500) {
        TotalQuestion = ans.length
      } else {
        TotalQuestion = ques
      }
      for (let i = 0; i < TotalQuestion; i++) {
        temp = mat[i][0] * mat[i][1]
        anskey.push(temp)
        temp = 1
        if (anskey[i] == ans[i]) {
          TotalCorrectAns++;
        }
      }
    }
    console.log(ch1)
    if (ch1 == "Dr" && ch == 'd') {
      if (ques == 500 || ques == 250) {
        TotalQuestion = ans.length
      } else {
        TotalQuestion = ques
      }
      for (let i = 0; i < TotalQuestion; i++) {
        temp = mat[i][0] % mat[i][1]
        anskey.push(temp)
        temp = 1
        if (anskey[i] == ans[i]) {
          TotalCorrectAns++;
        }
      }
    }
    if (ch1 == "Dn" && ch == 'd') {
      if (ques == 500 || ques == 250) {
        TotalQuestion = ans.length
      } else {
        TotalQuestion = ques
      }
      for (let i = 0; i < TotalQuestion; i++) {
        temp = mat[i][0] / mat[i][1]
        anskey.push(temp)
        temp = 1
        if (anskey[i] == ans[i]) {
          TotalCorrectAns++;
        }
      }
    }


    if (TotalCorrectAns) {
      Pop_up = ((TotalCorrectAns / TotalQuestion) * 100).toFixed(2)
      if (Pop_up) {
        if (25 <= Pop_up && Pop_up < 50) {
          m1 = 1;
        } else if (50 <= Pop_up && Pop_up < 80) {
          m3 = 1;
          m2 = 1;
        } else if (80 <= Pop_up && Pop_up <= 100) {
          m1 = 1;
          m2 = 1;
          m3 = 1;
        }
      }
    }

  }

  return (
    <div className='bladge-main'>
      <div className={m3 == 1 ? "quiz-medal" : "no-dis-blage"}>
        <div class="quiz-medal__circle quiz-medal__circle--bronze">
          <span>
            {/* 3 */}
          </span>
        </div>
        <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
        <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
      </div>
      {/* <div class="quiz-medal"> */}
      <div className={m2 == 1 ? "quiz-medal" : "no-dis-blage"}>
        <div class="quiz-medal__circle quiz-medal__circle--silver">
          <span>
            {/* 2 */}
          </span>
        </div>
        <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
        <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
      </div>

      {/* <div class="quiz-medal"> */}
      <div className={m1 == 1 ? "quiz-medal" : "no-dis-blage"}>
        <div class="quiz-medal__circle quiz-medal__circle--gold">
          <span>
            {/* 1 */}
          </span>
        </div>
        <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
        <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
      </div>
      {/* <div class="quiz-medal">
            <div class="quiz-medal__circle">
            </div>
            <div class="quiz-medal__ribbon quiz-medal__ribbon--left"></div>
            <div class="quiz-medal__ribbon quiz-medal__ribbon--right"></div>
          </div> */}
    </div>
  )
}

export default Bladge
